import { apiClient } from '@/libs/http-client';

const prefixUrl = import.meta.env.VITE_MIDDLEWARE_BASE_URL;

export enum TeamsNotificationType {
  Started = 'started',
  Progress = 'progress',
  Completed = 'completed',
}

export const sendTeamsNotification = async ({
  name,
  email,
  type,
  message,
}: {
  name: string;
  email: string;
  message?: string;
  type: TeamsNotificationType;
}) => {
  await apiClient()
    .post('tour-teams-feedback', { prefixUrl, json: { name, email, type, message } })
    .text();
};
